<onyx-section [heading]="`${I18N}.heading.${type()}`" justify="right">
  <div rightHeading class="heading">
    @if (isOptional()) {
      <onyx-toggle
        data-testid="show-form-toggle"
        [(checked)]="showForm"
      ></onyx-toggle>
    }
  </div>

  @if (template()) {
    <div options class="copy-template" [class.success]="copyTemplateSuccess()">
      <onyx-button
        class="button"
        variant="outlined"
        [size]="32"
        [disabled]="copyTemplateDisabled()"
        (click)="copyTemplateDisabled() ? null : copyTemplate()"
      >
        {{ `${I18N}.copyTemplate` | translate }}
      </onyx-button>

      <onyx-icon
        class="icon"
        name="check-circle-filled"
        [size]="20"
      ></onyx-icon>
    </div>
  }

  <form [formGroup]="form()">
    @let controls = form().controls;
    <onyx-text-field
      data-testid="insurance-number-field"
      [formControl]="controls.insuranceNumber"
      label="labels.insuranceNumber"
      [size]="32"
    ></onyx-text-field>

    <onyx-datepicker
      data-testid="expiry-date-datepicker"
      [formControl]="controls.expiryDate"
      label="labels.expirationDate"
      [yearsRange]="{ past: 0, future: 10 }"
      [warningTypes]="['pastDate']"
      [size]="32"
    ></onyx-datepicker>

    <ng-container
      *ngTemplateOutlet="
        amountTemplate;
        context: { testId: 'annual-cost', name: 'annualCost' }
      "
    ></ng-container>

    <ng-container
      *ngTemplateOutlet="
        amountTemplate;
        context: { testId: 'insurance-sum', name: 'insuranceSum' }
      "
    ></ng-container>

    <onyx-upload
      data-testid="contract-scan-upload"
      [formControl]="controls.contractScan"
      label="labels.contractScan"
      [size]="32"
    ></onyx-upload>
  </form>
</onyx-section>

<ng-template let-testId="testId" let-name="name" #amountTemplate>
  @let formGroup = form().get(name)!;
  <onyx-form-group
    [formGroup]="$any(formGroup)"
    [label]="`labels.${name}`"
    [controls]="[formGroup.get('value')!, formGroup.get('currency')!]"
    (labelClick)="amountValueControlElement.focus()"
  >
    @let controls = $any(formGroup).controls;
    <onyx-text-field
      [attr.data-testid]="`${testId}-value-field`"
      [formControl]="controls.value"
      [decimalPlaces]="2"
      [showErrors]="false"
      #amountValueControlElement
      [size]="32"
    ></onyx-text-field>

    <onyx-dropdown
      [attr.data-testid]="`${testId}-currency-dropdown`"
      [formControl]="controls.currency"
      [options]="currencies$ | async"
      [optional]="false"
      width="max-content"
      [showErrors]="false"
      [size]="32"
    ></onyx-dropdown>
  </onyx-form-group>
</ng-template>
